module.exports = __webpack_public_path__ + "img/book-open.c58fe9ef.svg";